import React from "react";
import Heading from "./Heading"; // Ensure this component is properly defined in your project
import { BsHourglassSplit, BsGraphUpArrow } from "react-icons/bs";
import { PiTreeViewLight } from "react-icons/pi";
import { Helmet } from "react-helmet";
import Goal from './../image/Goal.mp4'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const GrowingWithClients = () => {
  return (
    <div className="bg-white flex flex-col md:flex-row lg:p-6 p-4 w-full max-w-[1320px] gap-10 mb-20 ">
   
      {/* Left Side - Text Content */}
      <div className="flex-1">
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          <div className="flex-1 mt-10">
            <h1 className="text-[30px] md:text-[50px] lg:text-[62px] text-black font-[700] leading-[1] mb-3">Growing With <span className="text-[#0e55a8]"> Our Clients </span></h1>
            <p className="text-[18px] text-[#363638] font-[500] "> We build lasting partnerships through innovation and sustainable growth.</p>
            <p className="text-[#6d6d70] text-[16px]  mt-6 mb-4 leading-[2] lg:text-justify text-left">
              Identify immediate opportunities for value-added beta testing to address the digital divide and improve DevOps efficiency. Leverage emerging technologies, such as AI, ML, and LLM, to deliver a more holistic approach that goes beyond just financial outcomes.
            </p>
            <p className="text-[#6d6d70] text-[16px] mb-4 leading-[2] lg:text-justify text-left">
              Leverage agile methodologies to deliver strategic insights and iterative solutions, fostering collaboration and enhancing client value. Emphasize disruptive innovation and a diverse approach to catalyze organic growth.
            </p>
          </div>

         
          <div className="w-full lg:w-1/2 relative mt-20 mb-20 sm:flex-row z-0">

                  {/* Video on Small Screens */}
                  <motion.video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="object-fill w-full h-[40vh] sm:block lg:hidden"
                    initial={{ scale: 1 }}
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatType: 'reverse' }}
                  >
                    <source src={Goal} type="video/mp4" />
                  </motion.video>

                  {/* Top Left Box */}
                  <motion.div
                    initial={{ opacity: 0.8, scale: 1 }}
                    animate={{
                      rotate: [0, 10, -10, 0],
                      scale: [1, 1.05, 1],
                      opacity: [0.8, 1, 0.8],
                      y: [0, -10, 0],
                    }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatDelay: 2 }}
                    className="bg-gradient-to-r from-gray-200 to-[#c2e1f8] w-[160px] text-white p-4 rounded-md shadow-lg
  hidden lg:block lg:absolute -top-10 -left-5 z-10"
                  >
                    <h4 className="text-md font-semibold text-[#0e55a8]">Consistency</h4>
                    <p className="text-[13px] text-gray-600">
                    Integrate podcasting into operational change management within workflows.
                    </p>
                   
                  </motion.div>

                 {/* Top Right Box */}
<motion.div
  initial={{ opacity: 0.8, scale: 1 }}
  animate={{
    rotate: [0, -10, 10, 0],
    scale: [1, 1.05, 1],
    opacity: [0.8, 1, 0.8],
    y: [0, -10, 0],
  }}
  transition={{ duration: 8, ease: "easeInOut", repeat: Infinity, repeatDelay: 2 }}
  className="bg-gradient-to-l from-white to-[#d3e4f1] w-[160px] text-white p-4 rounded-md shadow-lg 
  hidden lg:block lg:absolute -top-10 right-5 z-10"
>
  <h4 className="text-md font-semibold text-[#0e55a8]">Improvement</h4>
  <p className="text-[13px] text-gray-600">
    Continuously innovate customer service to deliver a cutting-edge experience.
  </p>
</motion.div>

                  {/* Bottom Left Box */}
                  <motion.div
                    initial={{ opacity: 0.8, scale: 1 }}
                    animate={{
                      rotate: [0, -10, 10, 0],
                      scale: [1, 1.05, 1],
                      opacity: [0.8, 1, 0.8],
                      y: [0, -10, 0],
                    }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatDelay: 2 }}
                    className="bg-gradient-to-l from-white to-[#d3e4f1] w-[160px] text-white p-4 rounded-md shadow-lg 
  hidden lg:block lg:absolute -bottom-10 right-5 z-10">
                    <h4 className="text-md font-semibold text-[#0e55a8]">Branching</h4>
                    <p className="text-[13px] text-gray-600">
                    Explore scalable customer service solutions through sustainable opportunities.
                    </p>
                  </motion.div>

                  {/* Video for Large Screens */}
                  <motion.video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="object-cover w-full h-full hidden lg:block z-0"
                    initial={{ scale: 1 }}
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatType: 'reverse' }}
                  >
                    <source src={Goal} type="video/mp4" />
                  </motion.video>
                </div>

        </div>
      </div>
    </div>
  );
};

export default GrowingWithClients;
